// libraries.
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// slices.
import { DocumentsTool } from '../../../../DocumentsVisualizer/interfaces/sideBar.types';
import { selectSidebarButton } from '@shared/Sidebar/store/slices/sidebar-slice';

// components.
import { ButtonSidebar } from '@shared';

// assets.
import { IconGeorref } from '@assets/icons';

export const ButtonGeoreferencing = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(selectSidebarButton(DocumentsTool.georeferencing));
    navigate('/document-audit/georeferencing');
  };

  return (
    <ButtonSidebar
      icon={<IconGeorref fill="white" />}
      text="Georreferenciación"
      onClick={handleClick}
    />
  );
};
